<template>
  <el-dialog
    width="650px"
    :title="'Sửa cài đặt quy trình' + ''"
    :visible="visible"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="show_fields"
label="Trường hiển thị">
            <el-select
              v-model="form.show_fields"
              placeholder="Chọn trường dữ liệu"
              filterable
              multiple
              clearable
              class="w-100"
            >
              <el-option
                v-for="field in fields"
                :key="field.key"
                :label="field.name"
                :value="field.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="update_fields"
label="Trường cập nhật">
            <el-select
              v-model="form.update_fields"
              placeholder="Chọn trường dữ liệu"
              filterable
              multiple
              clearable
              class="w-100"
            >
              <el-option
                v-for="field in fields.filter((f) => form.show_fields.includes(f.key))"
                :key="field.key"
                :label="field.name"
                :value="field.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <div
            style="display: flex; align-items: center; justify-content: space-between;"
          >
            <p class="mb-0">Trường truy vết</p>
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-plus"
              @click="addLogField"
            />
          </div>
          <el-row
          v-for="(log_field, index) in form.log_fields"
            :key="index"
            label-position="top"
            type="flex"
            align="start"
            class="flex-wrap"
            :gutter="12"
          >
            <el-col :span="6">
              <el-form-item
                label="Mã trường"
                :prop="'log_fields.' + index + '.key'"
              >
                <el-input
v-model="log_field.key"
placeholder="Nhập mã" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Tên trường"
                :prop="'log_fields.' + index + '.name'"
              >
                <el-input
v-model="log_field.name"
placeholder="Nhập tên" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="Loại trường"
                :prop="'log_fields.' + index + '.type'"
              >
                <el-select
                  v-model="log_field.type"
                  placeholder="Chọn loại"
                  class="w-100"
                >
                  <el-option
                    v-for="op in typeOptions"
                    :key="op.key"
                    :label="op.label"
                    :value="op.key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
:span="4"
style="display: flex; justify-content: flex-end;">
              <el-form-item
                label="Xoá"
              >
                <el-button
icon="el-icon-close"
type="danger"
@click="() => deleteLogField(index)"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import PATTERNS from "@/config/patterns.js";
import CONSTANTS from "@/config/constants";

export default {
  name: "ContractStepFormPopup",
  props: {
    visible: Boolean,
    item: Object,
    fields: Array,
    currentStep: Object,
    defaultStep: Object
  },
  data() {
    return {
      loading: false,
      form: {
        show_fields: this.item ? this.item.show_fields : [],
        update_fields: this.item ? this.item.update_fields : [],
        log_fields: this.item ? this.item.log_fields : [],
      },
    };
  },
  computed: {
    typeOptions() {
      return CONSTANTS.FIELD_TYPES.filter((t) => t.key !== CONSTANTS.FIELD_TYPE.MODULE);
    },
    rules() {
      const validateKey = (rule, value, callback) => {
        if (value && CONSTANTS.BLOCK_KEYS.includes(value.trim())) {
          callback(new Error("Mã trường trùng với mã hệ thống"));
        } else if (value && this.form.log_fields.filter((f) => value.trim() == f.key).length > 1) {
          callback(new Error("Mã trường đã tồn tại"));
        } else {
          callback();
        }
      };
      const logFieldRules = {};
      this.form.log_fields.forEach((field, index) => {
        logFieldRules[`log_fields.${index}.key`] = [
          {
            required: true,
            message: "Mã không được để trống",
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.KEY,
            message: "Mã nhóm không hợp lệ",
            trigger: ["blur", "change"],
          },
          {
            validator: validateKey,
            trigger: ["blur", "change"],
          },
        ];
        logFieldRules[`log_fields.${index}.name`] = [
          {
            required: true,
            message: "Tên không được để trống",
            trigger: ["blur", "change"],
          }
        ]
      });
      return logFieldRules
    },
  },
  beforeMount() {
    if (this.defaultStep && this.form.show_fields.length === 0) {
      this.form.show_fields = this.defaultStep.show_fields || []
    }
  },
  methods: {
    addLogField() {
      this.form.log_fields.push({
        key: "",
        name: "",
        type: CONSTANTS.FIELD_TYPE.TEXT
      })
    },
    deleteLogField(index) {
      this.form.log_fields = this.form.log_fields.filter((_, i) => i !== index)
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('save', {
            ...this.item,
            ...this.form
          })
          this.$emit('close')
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
